export default "__VITE_ASSET__BZcDKrHi__"